import { createSlice } from '@reduxjs/toolkit'


const INITIAL_STATE = {
    visitedRoutes: []
}

const visitedRoutesSlice = createSlice({
    name: 'visitedRoutes',
    initialState: INITIAL_STATE,
    reducers: {
        saveVisitedRoute(state, action) {
            const toLink = action.payload.route.toLink.replace(/\/$/, '')
            const i = state.visitedRoutes.findIndex(e => e.toLink && e.toLink === toLink)
            if (i > -1) {
                state.visitedRoutes[i] = action.payload.route
            } else {
                state.visitedRoutes.push(action.payload.route)
            }
        }
    }
})

export const { saveVisitedRoute } = visitedRoutesSlice.actions
export default visitedRoutesSlice.reducer
